module.exports = __webpack_public_path__ + "static/media/HeroBannerImage.ba012332.webp";